import {
  defaultColor,
  themeSelectedColorStorageKey,
  themeRadiusStorageKey,
  localeOptions,
  defaultLocale
} from '@/constants/config'

/* Regex */
export const decimalRegex = /^\d*\.?\d*$/

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    const A = a[key]
    const B = b[key]
    if (order.indexOf(A + '') > order.indexOf(B + '')) {
      return 1
    } else {
      return -1
    }
  })
  return array
}

export const getDateWithFormat = (date = new Date()) => {
  let dd = date.getDate()
  let mm = date.getMonth() + 1
  const yyyy = date.getFullYear()
  if (dd < 10) {
    dd = '0' + dd
  }
  if (mm < 10) {
    mm = '0' + mm
  }
  return yyyy + '-' + mm + '-' + dd
}

export const getDateWithFormatCustom = (date = new Date(), separator = '.') => {
  let dd = date.getDate()
  let mm = date.getMonth() + 1
  const yyyy = date.getFullYear()
  let hours = date.getHours()
  let minutes = date.getMinutes()
  if (dd < 10) {
    dd = '0' + dd
  }
  if (mm < 10) {
    mm = '0' + mm
  }
  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  return dd + separator + mm + separator + yyyy + ', ' + `${hours}:${minutes}`
}

export const getCurrentTime = () => {
  const now = new Date()
  return now.getHours() + ':' + now.getMinutes()
}

export const ThemeColors = () => {
  let rootStyle = getComputedStyle(document.body)
  return {
    themeColor1: rootStyle.getPropertyValue('--theme-color-1').trim(),
    themeColor2: rootStyle.getPropertyValue('--theme-color-2').trim(),
    themeColor3: rootStyle.getPropertyValue('--theme-color-3').trim(),
    themeColor4: rootStyle.getPropertyValue('--theme-color-4').trim(),
    themeColor5: rootStyle.getPropertyValue('--theme-color-5').trim(),
    themeColor6: rootStyle.getPropertyValue('--theme-color-6').trim(),
    themeColor1_10: rootStyle.getPropertyValue('--theme-color-1-10').trim(),
    themeColor2_10: rootStyle.getPropertyValue('--theme-color-2-10').trim(),
    themeColor3_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
    themeColor4_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
    themeColor5_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
    themeColor6_10: rootStyle.getPropertyValue('--theme-color-3-10').trim(),
    primaryColor: rootStyle.getPropertyValue('--primary-color').trim(),
    foregroundColor: rootStyle.getPropertyValue('--foreground-color').trim(),
    separatorColor: rootStyle.getPropertyValue('--separator-color').trim()
  }
}

export const getThemeColor = () => {
  let color = defaultColor
  try {
    if (localStorage.getItem(themeSelectedColorStorageKey)) {
      color = localStorage.getItem(themeSelectedColorStorageKey) || defaultColor
    }
  } catch (error) {
    console.error(error)
    color = defaultColor
  }
  return color
}

export const setThemeColor = (color) => {
  try {
    localStorage.setItem(themeSelectedColorStorageKey, color)
  } catch (error) {
    console.error(error)
  }
}

export const getThemeRadius = () => {
  let radius = 'rounded'
  try {
    if (localStorage.getItem(themeRadiusStorageKey)) {
      radius = localStorage.getItem(themeRadiusStorageKey) || 'rounded'
    }
  } catch (error) {
    console.error(error)
    radius = 'rounded'
  }
  return radius
}

export const setThemeRadius = (radius) => {
  try {
    localStorage.setItem(themeRadiusStorageKey, radius)
  } catch (error) {
    console.error(error)
  }
}

export const getCurrentLanguage = () => {
  let locale = defaultLocale
  try {
    if (
      localStorage.getItem('currentLanguage') &&
      localeOptions.filter((x) => x.id === localStorage.getItem('currentLanguage')).length > 0
    ) {
      locale = localStorage.getItem('currentLanguage')
    }
  } catch (error) {
    console.error(error)
    locale = defaultLocale
  }
  return locale
}

export const setCurrentLanguage = (lang) => {
  try {
    localStorage.setItem('currentLanguage', lang)
  } catch (error) {
    console.error(error)
  }
}

export const getCurrentUser = () => {
  let user
  try {
    user = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null
  } catch (error) {
    console.error(error)
    user = null
  }
  return user
}

export const setCurrentUser = (user) => {
  try {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user))
    } else {
      localStorage.removeItem('user')
    }
  } catch (error) {
    console.error(error)
  }
}

export const getToken = () => {
  let token
  try {
    token = localStorage.getItem('token') !== null ? localStorage.getItem('token') : null
  } catch (error) {
    console.error(error)
    token = null
  }
  return token
}

export const setToken = (token) => {
  try {
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  } catch (error) {
    console.error(error)
  }
}

export const ObjectFilterOut = (object, filterKeys) => {
  let langFilterKeys = []
  for (const key of filterKeys) {
    langFilterKeys.push(key.concat('_', 'en'))
    langFilterKeys.push(key.concat('_', 'ru'))
  }
  const asArray = Object.entries(object)
  const filtered = asArray.filter(
    // eslint-disable-next-line no-unused-vars
    ([key, _value]) => !langFilterKeys.includes(key)
  )
  return Object.fromEntries(filtered)
}

export const handleArrayDataInternalization = (data, langKeys, currentLang) => {
  switch (currentLang) {
    case 'en':
      return data.map((i) => {
        const langData = {}

        for (const key of langKeys) {
          const langKey = key.concat('_', 'en')
          if (i[langKey]) {
            langData[key] = i[langKey]
          }
        }

        return {
          ...ObjectFilterOut(i, langKeys),
          ...langData
        }
      })

    case 'ru':
      return data.map((i) => {
        const langData = {}

        for (const key of langKeys) {
          const langKey = key.concat('_', 'ru')
          if (i[langKey]) {
            langData[key] = i[langKey]
          }
        }

        return {
          ...ObjectFilterOut(i, langKeys),
          ...langData
        }
      })

    default:
      return []
  }
}

export const handleObjectInternalization = (data, langKeys, currentLang) => {
  const langData = {}
  switch (currentLang) {
    case 'en':
      for (const key of langKeys) {
        const langKey = key.concat('_', 'en')
        if (data[langKey]) {
          langData[key] = data[langKey]
        }
      }

      return {
        ...ObjectFilterOut(data, langKeys),
        ...langData
      }

    case 'ru':
      for (const key of langKeys) {
        const langKey = key.concat('_', 'ru')
        if (data[langKey]) {
          langData[key] = data[langKey]
        }
      }

      return {
        ...ObjectFilterOut(data, langKeys),
        ...langData
      }

    default:
      return []
  }
}

export const formatPrice = (number, n, x, s, c) => {
  /**
   * Number.prototype.format(n, x, s, c)
   *
   * @param number number: number to format
   * @param integer     n: length of decimal
   * @param integer     x: length of whole part
   * @param mixed       s: sections delimiter
   * @param mixed       c: decimal delimiter
   */
  const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')'
  const num = number.toFixed(Math.max(0, ~~n))

  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','))
}
